import countryReducer from './country-reducer';

export default countryReducer;
